import React from 'react';

export interface TabsContextProps {
	active: number;
	activate: (index: number) => void;
}

export const TabsContext = React.createContext<TabsContextProps | null>(null);
